module.exports = __webpack_public_path__ + "static/media/mandiri.3122062e.svg";